import React, { createContext, useContext, useState } from 'react';
import { Snackbar, Alert } from '@mui/material';

// 1. Creamos el contexto
const ToastContext = createContext();

// 2. Exportamos el Hook para poder usarlo en NuevoPaciente, Agenda, etc.
export const useToast = () => useContext(ToastContext);

// 3. Creamos el Proveedor que envolverá nuestra App
export const ToastProvider = ({ children }) => {
    const [toast, setToast] = useState({
        open: false,
        message: '',
        severity: 'info' // Puede ser: 'success', 'error', 'warning', 'info'
    });

    // Función que llamaremos desde los componentes
    const showToast = (message, severity = 'info') => {
        setToast({ open: true, message, severity });
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') return; // Evita que se cierre si haces clic fuera
        setToast({ ...toast, open: false });
    };

    return (
        <ToastContext.Provider value={{ showToast }}>
            {children}

            {/* El Snackbar global que aparecerá por encima de todo */}
            <Snackbar
                open={toast.open}
                autoHideDuration={4000}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Alert onClose={handleClose} severity={toast.severity} sx={{ width: '100%' }} variant="filled">
                    {toast.message}
                </Alert>
            </Snackbar>
        </ToastContext.Provider>
    );
};